import "./index.css";
import { clsx } from "clsx";
import { Button } from "../Button/Button";
import type { IButtonSize } from "../Button/types";
import type { IEmptyStateProps, IEmptyStateSize } from "./types";

const buttonSize: Record<IEmptyStateSize, IButtonSize> = {
  xs: "xs",
  sm: "sm",
  md: "sm",
  lg: "md",
};

export const EmptyState = ({
  icon,
  title,
  text,
  buttonProps,
  secondButtonProps,
  className,
  size = "sm",
}: IEmptyStateProps) => {
  const rootClass: string = clsx(
    "nuco-emptyState",
    `nuco-emptyState--${size}`,
    icon && `nuco-emptyState--withIcon`,
    className,
  );

  return (
    <div className={rootClass}>
      <div className="nuco-emptyState__inner">
        {!!icon && (
          <div className="nuco-emptyState__illustration" role="presentation">
            {icon}
          </div>
        )}
        {!!title && <h3 className="nuco-emptyState__heading">{title}</h3>}
        {!!text && <p className="nuco-emptyState__text">{text}</p>}
        {!!buttonProps && (
          <div className="nuco-emptyState__actions">
            {secondButtonProps && (
              <Button size={buttonSize[size]} {...secondButtonProps} />
            )}
            <Button size={buttonSize[size]} {...buttonProps} />
          </div>
        )}
      </div>
    </div>
  );
};
